<div class="metrics m-sm-30">
  <app-breadcrumb></app-breadcrumb>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
    <div class="col-span-1 md:col-span-2 grid grid-cols-12 gap-8">
      <div class="col-span-12 md:col-span-6">
        <div class="col-content">
          <mat-card
            class="usage-card bg-primary p-16 py-24 text-center"
          >
            <div class="py-16 text-2xl uppercase text-white">Process metrics summary</div>
            <div class="px-20 flex justify-between">
              <div class="text-white">
                <div class="font-bold text-lg">220Mb</div>
                <p class="font-light uppercase m-4">RAM used</p>
              </div>
              <div class="text-white">
                <div class="font-bold text-xl">320</div>
                <p class="font-light uppercase m-4">Attestations</p>
              </div>
              <div class="text-white">
                <div class="font-bold text-xl">4</div>
                <p class="font-light uppercase m-4">Blocks missed</p>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-span-12 md:col-span-3">
        <div class="col-content">
          <mat-card class="bg-paper">
            <div class="px-4 pt-6 pb-16">
              <div class="card-title text-white font-bold text-lg">Profitability</div>
              <div class="card-subtitle mt-2 mb-8 text-white">$323</div>
              <button mat-raised-button color="primary">
                + 0.32 pending ETH
              </button>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-span-12 md:col-span-3">
        <div class="col-content">
          <mat-card class="bg-paper">
            <div class="px-4 pt-6 pb-16">
              <div class="card-title text-white font-bold text-lg">RPC Traffic Sent</div>
              <div class="card-subtitle mt-2 mb-8 text-white">2.4Gb</div>
              <button mat-raised-button color="accent">
                Total Data
              </button>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
    <div class="col-span-1">
      <mat-card class="bg-paper">
        <app-balances-chart></app-balances-chart>
      </mat-card>
    </div>
    <div class="col-span-1">
      <mat-card class="bg-paper">
        <app-proposed-missed-chart></app-proposed-missed-chart>
      </mat-card>
    </div>
    <div class="col-span-1">
      <mat-card class="bg-paper">
        <app-double-bar-chart></app-double-bar-chart>
      </mat-card>
    </div>
    <div class="col-span-1">
      <mat-card class="bg-paper">
        <app-pie-chart></app-pie-chart>
      </mat-card>
    </div>
  </div>
</div>